import { lazy } from 'react';

import { retry } from 'utils/retry';

const PageNotFound404 = lazy(() => retry(() => import('./PageNotFound404')));

export { PageNotFound404 };
